import { TableRow } from "./components/Chart";

export function getPercentage(current: number, total: number): number {
  return Math.floor((current / total) * 100);
}

export const QUOTE_HEADERS = ["Quote"];

export function quoteToTableRow({ quote }: { quote: string }): TableRow {
  return {
    values: [quote],
  };
}

function padStart(value: number): string {
  return value.toString().padStart(2, "0");
}

export function toUKDateString(date: Date): string {
  return `${padStart(date.getDate())}/${padStart(date.getMonth() + 1)}/${date.getFullYear()}`;
}

export function titleToId(title: string): string {
  return title.toLowerCase().replaceAll(" ", "-");
}
